// Tipos de página según especificación de Jakala
export const PAGE_TYPES = {
  HOME: 'home',
  BUY_ONLINE: 'buy online',
  CONTACT: 'contact',
  STORE_LOCATOR: 'store locator',
  CONFIGURATOR: 'configurator',
  COMPARATOR: 'comparator',
  WHO_WE_ARE: 'who we are',
  PROMOTIONS: 'promotions',
  NEWSLETTER: 'newsletter',
  PRODUCT: 'product',
  OTHER: 'other'
};

// Nombres de eventos GTM
export const GTM_EVENTS = {
  DL_START: 'dl_start',
  STORE_LOCATOR_MAPS: 'store_locator_maps',
  STORE_LOCATOR_WEBSITE: 'store_locator_website',
  STORE_LOCATOR_PHONE: 'store_locator_phone',
  RESULTS_INTERACTION: 'results_interaction',
  START_CONFIGURATOR: 'start_configurator',
  CONFIGURATOR_QUESTION: 'configurator_question',
  END_CONFIGURATION: 'end_configuration'
};
